export default __webpack_public_path__ + "static/media/skelly_0001.cc01a3d3.png";